module.exports = __webpack_public_path__ + "static/media/optimal-networks.7b1694a5.png";